import axios from 'axios';

const setTotalConsumptionAmount = function () {
  let totalAmount = 0;
  $('.partial-pellet-amount:visible').each(function () {
    const amount = $(this).val();
    if (!Number.isNaN(amount) && amount.length !== 0) {
      totalAmount += parseFloat(amount);
    }
  });
  $('.pellet_consumption-total-amount').text(totalAmount.toFixed(2));
};

const updateProducts = async () => {
  const orderId = $('#pellet_consumption_production_order_id').val();
  if (!orderId) return;

  try {
    const res = await axios.get('/pellet_consumptions/products_by_order.json', {
      params: {
        production_order_id: orderId,
      },
    });
    const products = res.data;
    const select = $('#pellet_consumption_product_id');
    select.empty();
    products.forEach(function (product) {
      select.append(
        $('<option>', {
          text: product.code_and_name,
          value: product.id,
        })
      );
    });
    select.trigger('change');
  } catch (error) {
    console.log(error);
  }
};

document.addEventListener('turbolinks:load', function () {
  $('#partial_pellet_consumptions_table').on(
    'keyup',
    'input',
    setTotalConsumptionAmount
  );
  $('#partial_pellet_consumptions_table').on(
    'cocoon:after-remove',
    function () {
      setTotalConsumptionAmount();
    }
  );
  $('#pellet_consumption_production_order_id').on('change', updateProducts);
});
